// src/components/lead-tracker/ReferredByPicker.jsx
// Shared "pick a referrer" modal: choose an existing contact (the current
// user's contacts, same scope as every other picker in TES) or create a new
// one. onDone receives { contactId, name } or null when cleared.
import React, { useState } from "react";
import { toast } from "react-toastify";
import AddClientPicker from "../new-contact/AddClientPicker";
import ContactEditDrawer from "../new-contact/ContactEditDrawer";
import { addContact } from "../../utils/contactsApi";
import { normalizeContact } from "../../utils/contactNormalize";
import { getContactsByIds } from "../../utils/firebasefunctions";
import { useStateValue } from "../../context/StateProvider";

export default function ReferredByPicker({ excludeContactId, onDone, onClose }) {
  const [{ user }] = useStateValue();
  const [creating, setCreating] = useState(false);
  const [saving, setSaving] = useState(false);

  const pick = async (contactId) => {
    try {
      const [raw] = await getContactsByIds([contactId]);
      const c = raw ? normalizeContact(raw) : null;
      onDone({ contactId, name: c?.name || "" });
    } catch (e) {
      onDone({ contactId, name: "" });
    }
  };

  const createNew = async (form) => {
    setSaving(true);
    try {
      const saved = await addContact({ user, contact: form });
      const c = normalizeContact(saved);
      onDone({ contactId: saved.firebaseId || c.id, name: c.name || "" });
    } catch (e) {
      toast.error(e.message || "Failed to create contact");
      setSaving(false);
    }
  };

  if (creating) {
    return (
      <ContactEditDrawer
        onClose={() => setCreating(false)}
        onSubmit={createNew}
        saving={saving}
      />
    );
  }
  return (
    <AddClientPicker
      userId={user?.id}
      existingCustomerIds={excludeContactId ? [excludeContactId] : []}
      onClose={onClose}
      onPick={pick}
      onCreateNew={() => setCreating(true)}
    />
  );
}
